import { Routes, Route } from 'react-router-dom';
import './App.css';
import MainPage from './components/MainPage';
import TalkingOutLoudforKids from './components/TalkingOutLoudforKids';
import TalkingOutLoudforEveryone from './components/TalkingOutLoudforEveryone';
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  return (
    <div>
      <Routes>
        <Route exact path="/" element={<MainPage />} />
        <Route
          exact
          path="/TalkingOutLoudforKids"
          element={<TalkingOutLoudforKids />}
        />
        <Route
          exact
          path="/TalkingOutLoudforEveryone"
          element={<TalkingOutLoudforEveryone />}
        />
        <Route
          exact
          path="/PrivacyPolicy"
          element={<PrivacyPolicy />}
        />
      </Routes>
    </div>
  );
}

export default App;
